export const PAYMENT_STEPS = {
  INFO: 1,
  PAYMENT: 2,
  SUCCESS: 3,
};
